<template>
  <div
    class="product-item-pr"
    :class="
      item.mmsta == '99'
        ? 'is-soldout'
        : item.zzprdTyp == 'A'
          ? 'is-another'
          : ''
    "
  >
    <div class="c-checkbox c-checkbox-pr-pc type-small type-line-margin">
      <input
        type="checkbox"
        :id="'basket-chk-' + index"
        name="basket-group1"
        :checked="checkedValue"
        @change="toggleItem()"
      />
      <label :for="'basket-chk-' + index">
        <span class="sr-only">상품선택</span>
      </label>
    </div>

    <div class="product-info-pr" style="display: flex; width: 100%">
      <div class="product-details-pr">
        <span class="product-code-pr" @click="openProdInfoPop(item)">{{
          item.matnr
        }}</span>
        <div class="product-title-pr" @click="openProdInfoPop(item)">
          {{ item.zzmaktx }}
        </div>
      </div>
      <!-- </div> -->

      <div
        class="counter-box-pr"
        :class="
          item.mmsta == '99'
            ? 'is-soldout'
            : item.zzprdTyp == 'A'
              ? 'is-another'
              : ''
        "
      >
        <div class="product-price">
          {{ Number(item.kbetr * item.goodsQty).toLocaleString() }}원
        </div>
        <div class="c-counter">
          <button
            type="button"
            class="btn-minus"
            :disabled="item.goodsQty <= 1"
            @click="() => item.goodsQty--"
          >
            <i class="c-icon icon-minus size-xxsmall"></i>
            <span class="sr-only">빼기</span>
          </button>
          <input
            type="number"
            title="수량입력"
            v-model="item.goodsQty"
            ref="myInput"
            @mousedown="handleMouseDown"
          />
          <button type="button" class="btn-plus" @click="() => item.goodsQty++">
            <i class="c-icon icon-plus-black size-xxsmall"></i>
            <span class="sr-only">더하기</span>
          </button>
        </div>
      </div>
      <div
        class="product-main product-main-pr"
        :class="
          item.mmsta == '99'
            ? 'is-soldout'
            : item.zzprdTyp == 'A'
              ? 'is-another'
              : ''
        "
      >
        <div class="action-buttons">
          <div class="c-btn-area-list c-btn-area-list-pr type-product">
            <!-- <button
              class="btn-pc-pr btn-outlined"
              @click="() => (data.totalStockListPopEl = true)"
            >
              재고확인
            </button> -->

            <button
              type="button"
              class="c-button type-white type-xsmall type-icon"
              data-basket="basket1"
              @click="() => emit('cart', { product: props.item, quantity: 1 })"
            >
              <i class="c-icon icon-basket-product"></i>
              <span class="sr-only">장바구니</span>
            </button>

            <button
              class="btn-pc-pr btn-primary btn-pc-pr-btn"
              @click="
                () => emit('buy', { ...props.item, quantity: item.goodsQty })
              "
            >
              주문서 담기
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <AlertWerks
    :totalStockListPopEl="data.totalStockListPopEl"
    :product="props.item"
    :werks="props.werks"
    @close="() => (data.totalStockListPopEl = false)"
  >
  </AlertWerks>
</template>

<script setup>
import {
  onMounted,
  ref,
  defineProps,
  defineEmits,
  computed,
  watch,
  reactive,
} from "vue";

import * as cmApi from "@/api/cmApi";
import AlertWerks from "@/components/paintpro/common/AlertWerks.vue";
const data = reactive({
  totalStockListPopEl: false,
});
const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
  index: {
    type: Number,
    require: true,
  },
  checked: {
    type: Boolean,
    require: true,
  },
  werks: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["buy", "checked", "detail", "ordertemp", "cart"]);

//const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
const item = ref(props.item); // 제품
//const imageErrorYn = ref(false);
const checkedValue = computed({
  get: () => props.checked,
  set: (value) => emit("checked", value),
});
const myInput = ref(null);

onMounted(() => {});

watch(
  () => props.item,
  (newValue) => {
    item.value = newValue;
  }
);

// 제품 상세 팝업
function openProdInfoPop(item) {
  emit("detail", item);
}

// 제품 수량 입력
watch(
  () => item.value.goodsQty,
  (newQty, oldQty) => {
    if (newQty < 1) {
      item.value.goodsQty = 1;
    } else if (newQty > 99999) {
      item.value.goodsQty = oldQty;
    } else {
      item.value.goodsQty = newQty;
    }
    updateItemQuantity(item.value.goodsSn, item.value.goodsQty);
  }
);

// 제품 수량 변경 API
async function updateItemQuantity(goodsSn, goodsQty) {
  const param = {
    goodsSn: goodsSn,
    goodsQty: goodsQty,
    cntsStrgYn: item.value.cntsStrgYn,
  };
  await cmApi.updateUserBasketProd(param);
}

// 체크박스
function toggleItem() {
  checkedValue.value = !checkedValue.value;
}

/*const productBadgeEmptyYn = computed(() => {
  return (
    item.value.setgdYn !== "Y" &&
    item.value.zzlqdCls !== "A" &&
    item.value.zzlqdCls !== "B" &&
    item.value.zzlqdCls !== "C" &&
    item.value.zzlqdCls !== "D" &&
    item.value.zzlqdtyCls !== "A" &&
    item.value.zzlqdtyCls !== "B" &&
    item.value.zzlqdtyCls !== "C"
  );
});*/

/*const isNoPcImage = computed(() => {
  return (
    Utils.isBlank(item.value.filePath) ||
    Utils.isBlank(item.value.physFileNm) ||
    imageErrorYn.value
  );
});*/

/*const imageFilePath = computed(() => {
  return FILE_CDN_URL + "/" + item.value.filePath + "/" + item.value.physFileNm;
});*/

const handleMouseDown = (event) => {
  event.preventDefault();
  myInput.value?.focus();
  myInput.value?.select();
};
</script>
